import React from "react";
import { useNavigate } from "react-router-dom";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TypographyContainer,
  TitleRow,
  IconWrapper,
} from "./Header.styled";
import { Typography, Tag, Icon } from "@ann/web-components";

const Header = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/v2/user-management/roles");
  };

  return (
    <HeaderContainer>
      <HeaderLeftContainer>
        <TypographyContainer>
          <TitleRow>
            <IconWrapper onClick={handleBackClick}>
              <Icon name="arrowLeft" size="medium" />
            </IconWrapper>
            <Typography category="title" size="small" weight="bold">
              Create role
            </Typography>
            <Tag text="Draft" color="neutral" size="medium" />
          </TitleRow>

          <Typography category="body" size="medium" weight="regular" color={"body"}>
            Set up a new role to manage permissions and access levels. You can start from a predefined setup or build one from scratch.
          </Typography>
        </TypographyContainer>
      </HeaderLeftContainer>
    </HeaderContainer>
  );
};

export default Header;

